class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    this.expires = this.dataset.expires;
    this.delay = this.dataset.delay;

    this.init();
  }

  init() {
    function float() {
      const group = document.querySelectorAll(".newsletter_pop_up_field");
      group.forEach(function (ele) {
        const input = ele.querySelector("input");

        input.addEventListener("focus", function () {
          ele.classList.add("label-up");
          ele.classList.add("focus");
        });

        input.addEventListener("blur", function () {
          ele.classList.remove("focus");
          if (!input.value) {
            ele.classList.remove("label-up");
          }
        });
      });
    }

    float();

    function floatAppt() {
      const group_appt = document.querySelectorAll(".appointment_form_field");
      group_appt.forEach(function (ele) {
        const input_appt = ele.querySelector("input");

        input_appt.addEventListener("focus", function () {
          ele.classList.add("label-up");
          ele.classList.add("focus");
        });

        input_appt.addEventListener("blur", function () {
          ele.classList.remove("focus");
          if (!input_appt.value) {
            ele.classList.remove("label-up");
          }
        });
      });
    }

    floatAppt();

    const cookieExpireSet = `${this.expires}`;
    const NewsletterPopupCookie = "__reza-newsletter_popup-cookie";
    const tempDelayTime = `${this.delay}`;
    const delayTime = parseInt(tempDelayTime);

    function getCookie(cname) {
      const name = cname + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    }

    const setCookie = (name, value, expire = 365, path = "/") => {
      const date = new Date();
      date.setTime(date.getTime() + expire * 24 * 3600 * 1000);
      const expires = date.toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=${path}`;
    };

    const popup = document.getElementById("newsletterPopup");
    const close = document.getElementById("newsletter_pop_up_close");
    const body = document.body;

    // Define the name of the cookie.
    const cookieName = NewsletterPopupCookie;

    // First get the cookie..
    const cookie = getCookie(cookieName);

    // ..then check if the cookie is not set.
    if (cookie !== "show") {
      // If it isn't set, show the popup
      setTimeout(() => {
        popup.style.display = "flex";
        // Let the popup visible above all
        document.querySelector("#MainContent").style.zIndex = "6";
        document.querySelector("body").style.overflow = "hidden";
      }, delayTime);

      // ..and add the event listener to close it.
      close.addEventListener("click", () => {
        // Set the cookie with the value show for 2 days..
        setCookie(cookieName, "show", cookieExpireSet);

        // ..and hide the popup
        popup.style.display = "none";
        // ..and normalize the zIndex
        document.querySelector("#MainContent").style.zIndex = "";
        document.querySelector("body").style.overflow = "visible";
      });

      body.addEventListener("click", (event) => {
        if (
          !event.target.closest(".newsletter_content") &&
          !(event.target == ".newsletter_content")
        ) {
          setCookie(cookieName, "show", cookieExpireSet);
          // ..and hide the popup
          popup.style.display = "none";
          // ..and normalize the zIndex
          document.querySelector("#MainContent").style.zIndex = "";
          document.querySelector("body").style.overflow = "visible";
        }
      });
    }
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
